import { useCallback, useState } from "react";
import PortalRequestsAndFormsService from "../../../services/portalRequestsAndFormsService";
import saveAs from "file-saver";

export const useDownload = (contractNumber: string) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const onDownload = useCallback(
    async (id: string, fileName: string) => {
      try {
        setIsLoading(true);

        const res: any = await PortalRequestsAndFormsService.download(
          contractNumber,
          id,
        );

        const blob = new Blob([res], { type: res.type });

        saveAs(blob, fileName);

        setIsLoading(false);
      } catch {
        setIsLoading(false);
      }
    },
    [contractNumber],
  );

  return { isLoading, onDownload };
};
